module.exports = __webpack_public_path__ + "static/tpp-creator04-a3c9893cb41b78d8c3defe645204197e.jpg";